export default class CensusDataByState {
  constructor(obj) {
    if (obj.by_states) {
      this.zip_code = obj.by_states.state;
      this.median_rent = obj.by_states.median_rent;
      this.median_household_income = obj.by_states.median_household_income;
      this.mean_household_income = obj.by_states.mean_household_income;
    }
  }
}
